import React, { memo, useCallback } from "react";
import MyLoteriaContent from "../type/viewLoteriaContent";
import { Button } from "antd";
import WordSelectedType from "../type/wordSelectType";
import ImageSelectedType from "../type/imageWithTextSelectType.jsx";

const ViewMyLoteria = ({ open, openChange, bingoType, bingoData,text }) => {
  const typeComponentMap = {
    Word: WordSelectedType,
    Letter: WordSelectedType,
    Image: ImageSelectedType,
    OnlyImage: ImageSelectedType,
  };

  const getSelectedComponent = useCallback(() => {
    return typeComponentMap[bingoType] || WordSelectedType;
  }, [bingoType]);

  const SelectedTypeComponent = getSelectedComponent();

  return (
    <>
      <Button onClick={openChange}  className="BingoViewBtns viewLoteria">
        {text}
      </Button>
      {open && (
        <MyLoteriaContent
          SelectedTypeComponent={SelectedTypeComponent}
          bingoType={bingoType}
          grid={bingoData}
          viewType={"viewMyLoteria"}
          text={text}
        />
      )}
    </>
  );
};

export default memo(ViewMyLoteria);
